import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppModeEnum } from '@project-types/AppModeEnum';



interface GlobalState {
	appMode: AppModeEnum,
};

const initialState: GlobalState = {
	appMode: AppModeEnum.initDataStart,
};



export const globalSlice = createSlice({
	name: 'global',
	initialState,
	reducers: {
		setAppMode: (state, action: PayloadAction<AppModeEnum>) => {
			let mode = action.payload;
			state.appMode = mode === AppModeEnum.initDataSuccess
				? AppModeEnum.appSuccess
				: mode;
		},
	},
});



export const { setAppMode } = globalSlice.actions;